import React from 'react'
import { createFileRoute } from '@tanstack/react-router'

import MealSimulationIndex from '@/features/meal-recommendations/MealSimulationIndex'
import {
  energyDistributionQuery,
  mealOfDayDivisionsQuery,
  simulationProfilesQuery,
} from '@/api/mealPlan'
import { ingredientsQuery } from '@/api/ingredients'
import { foodRestrictionsQuery, tagsQuery } from '@/api'

type MealSimulationSearch = {
  lang?: string
}

export const Route = createFileRoute('/meal-simulation/')({
  loader: async ({ context: { queryClient }, params }) => {
    const [
      tags,
      foodRestrictions,
      mealOfDayDivisions,
      ingredients,
      energyDistribution,
      simulationProfiles,
    ] = await Promise.all([
      queryClient.ensureQueryData(tagsQuery),
      queryClient.ensureQueryData(foodRestrictionsQuery),
      queryClient.ensureQueryData(mealOfDayDivisionsQuery),
      queryClient.ensureQueryData(ingredientsQuery()),
      queryClient.ensureQueryData(energyDistributionQuery),
      queryClient.ensureQueryData(simulationProfilesQuery),
    ])

    return {
      tags,
      foodRestrictions,
      mealOfDayDivisions,
      ingredients,
      energyDistribution,
      simulationProfiles,
    }
  },
  validateSearch: (search: Record<string, unknown>): MealSimulationSearch => {
    // validate and parse the search params into a typed state
    return {
      lang: search.lang as string | undefined,
    }
  },
  component: MealSimulationComponent,
})

function MealSimulationComponent() {
  const {
    tags,
    foodRestrictions,
    mealOfDayDivisions,
    ingredients,
    energyDistribution,
    simulationProfiles,
  } = Route.useLoaderData()

  const { lang } = Route.useSearch()

  return (
    <MealSimulationIndex
      tags={tags}
      allergens={foodRestrictions}
      defaultMealOfDayDivisions={mealOfDayDivisions}
      ingredients={ingredients}
      energyDistribution={energyDistribution}
      simulationProfiles={simulationProfiles}
      lang={lang}
    />
  )
}
